<template>
  <v-stepper class="stepper" :value="value">
    <v-stepper-header>
      <v-stepper-step step="1" :class="inFirstStep ? activeClass : 'dark-one'">
        {{ stepOneTitle }}
      </v-stepper-step>
      <v-stepper-step
        step="2"
        :class="inSecondStep ? activeClass : inFirstStep ? 'dark-one' : ''"
      >
        {{ stepTwoTitle }}
      </v-stepper-step>
      <v-stepper-step step="3" :class="inThirdStep ? activeClass : ''">
        {{ stepTreeTitle }}
      </v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content step="1">
        <template v-if="$scopedSlots[`step1`]">
          <slot name="step1"></slot>
        </template>
        <FinancialTable
          v-else
          :headers="headers"
          :slip-details-headers="slipDetailsHeaders"
          :partial-unified-headers="partialUnifiedHeaders"
          :items="contractPositions"
          :unit-financial-positions="unitFinancialPositions"
          :mode="mode"
          :no-data-text="noDataText"
          :sort-icon="sortIcon"
          :expand-column="expandColumn"
          :selectable="true"
          :ignore-previous="ignorePrevious"
          :totalKey="totalKey"
          @updateSelected="updateSelected"
        >
          <template #col-paidValue="props">
            <slot name="col-paidValue" v-bind="props" />
          </template>
          <template #listFooter="{ currentSelected, selectedTotal }">
            <template
              v-if="currentSelected != null && currentSelected.length > 0"
            >
              <tr
                class="stepper__footer"
                :style="{ opacity: currentSelected.length > 0 ? '1' : '0' }"
              >
                <td class="text-xs-center"></td>
                <td class="text-xs-center"></td>
                <td class="text-xs-center bold--text">
                  {{ totalLabel }}
                </td>
                <td
                  v-for="index in footerEmptyCols"
                  :key="index"
                  class="text-xs-center"
                ></td>
                <td class="text-xs-center bold--text">
                  {{ selectedTotal }}
                </td>
                <td class="total-btn-column">
                  <v-btn
                    v-if="!mobile"
                    :class="buttonClass"
                    @click="$emit('buttonClicked')"
                  >
                    <v-progress-circular
                      color="white"
                      indeterminate
                      v-if="buttonLoading"
                    ></v-progress-circular>
                    <span v-else>
                      {{ buttonText }}
                    </span>
                  </v-btn>
                </td>
              </tr>
              <tr
                v-if="mobile && currentSelected.length > 0"
                class="text-xs-center stepper__footer"
              >
                <td colspan="100%">
                  <v-btn :class="buttonClass" @click="$emit('buttonClicked')">
                    <v-progress-circular
                      color="white"
                      indeterminate
                      v-if="buttonLoading"
                    ></v-progress-circular>
                    <span v-else>
                      {{ buttonText }}
                    </span>
                  </v-btn>
                </td>
              </tr>
            </template>
          </template>
        </FinancialTable>
      </v-stepper-content>
      <v-stepper-content step="2">
        <slot name="step2"></slot>
      </v-stepper-content>
      <v-stepper-content step="3">
        <v-data-table
          v-if="inThirdStep"
          :headers="headers"
          :items="items"
          hide-actions
          disable-initial-sort
        >
          <template slot="items" slot-scope="props">
            <slot name="step3Items" v-bind="props"></slot>
          </template>
        </v-data-table>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
import FinancialTable from './FinancialTable.vue';
export default {
  name: 'table-stepper',
  components: {
    FinancialTable,
  },
  data() {
    return {};
  },
  methods: {
    updateSelected(v) {
      this.$emit('updateSelected', v);
    },
  },
  computed: {
    inFirstStep() {
      return this.value === '1';
    },
    inSecondStep() {
      return this.value === '2';
    },
    inThirdStep() {
      return this.value === '3';
    },
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    stepOneTitle: {
      type: String,
      required: true,
    },
    stepTwoTitle: {
      type: String,
      required: true,
    },
    stepTreeTitle: {
      type: String,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
    slipDetailsHeaders: { type: Array, default: () => [] },
    partialUnifiedHeaders: { type: Array, default: null },
    unitFinancialPositions: { type: Object, required: true },
    mode: { type: String, required: true },
    expandColumn: { type: String, default: 'slipsUnion' },
    items: {
      type: Array,
      required: true,
    },
    contractPositions: {
      type: Array,
      default: () => [],
    },
    itemKey: {
      type: String,
      required: true,
    },
    noDataText: {
      type: String,
      required: true,
    },
    sortIcon: {
      type: String,
      required: true,
    },
    activeClass: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    totalLabel: {
      type: String,
      required: true,
    },
    totalKey: {
      type: String,
      required: true,
    },
    buttonClass: {
      type: String,
      required: true,
    },
    buttonLoading: {
      type: Boolean,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    ignorePrevious: {
      type: Boolean,
    },
    footerEmptyCols: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.total-btn-column {
  padding: 0px;
  text-align: right;
  width: 170px;
}

.dark-one {
  background-color: #eeeeee !important;
  border-color: #eeeeee !important;

  &::after {
    content: '';
    @include breakpoint(not-mobile) {
      position: absolute;
      top: 0;
      left: 100%;
      right: 0;
      margin: 0 auto;
      width: 0;
      height: 0;
      border-top: solid 26px transparent;
      border-left: solid 26px #eeeeee !important;
      border-right: solid 26px transparent;
      border-bottom: solid 26px transparent;
    }
  }
}

.stepper {
  box-shadow: none;

  &__footer {
    background-color: #616161;
    color: #fff;
    width: 100%;
    border: none !important;

    td {
      border: none !important;
    }
  }

  >>> .v-input--selection-controls__input {
    input {
      opacity: 1 !important;
      width: 75% !important;
      height: 75% !important;
    }

    i {
      display: none !important;
    }
  }

  >>> .v-stepper__header {
    box-shadow: none;
    background-color: #f5f5f5;
    margin: 5px 0;
    height: 52px;
    @include breakpoint(mobile) {
      border-radius: 5px;
    }
  }

  >>> .v-stepper__content {
    padding: 24px 0;
  }

  >>> .v-stepper__step__step {
    color: var(--light-dark-color) !important;
    background-color: #fff !important;
  }

  >>> .v-stepper__step--active {
    @include breakpoint(mobile) {
      border-radius: 5px;
    }

    .v-stepper__label {
      font-weight: 400 !important;
    }

    &::after {
      content: '';
      @include breakpoint(not-mobile) {
        position: absolute;
        top: 0;
        left: 100%;
        right: 0;
        margin: 0 auto;
        width: 0;
        height: 0;
        border-top: solid 26px transparent;
        border-left: solid 26px var(--financial-color) !important;
        border-right: solid 26px transparent;
        border-bottom: solid 26px transparent;
      }
    }
  }

  >>> .v-stepper__step {
    flex: 3.3;
    align-items: center;
    justify-content: center;
    @include breakpoint(mobile) {
      padding: 15px;
    }

    &::after {
      content: '';
      @include breakpoint(not-mobile) {
        position: absolute;
        top: 0;
        left: 100%;
        right: 0;
        margin: 0 auto;
        width: 0;
        height: 0;
        border-top: solid 26px transparent;
        border-left: solid 26px #f5f5f5;
        border-right: solid 26px transparent;
        border-bottom: solid 26px transparent;
        z-index: 7;
      }
    }

    .v-stepper__label {
      font-weight: 500;
      color: #616161;

      @include breakpoint(mobile) {
        display: inline;
        font-size: 10px;
        margin-left: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/financial/TableStepper.vue